export const buildPharmacies = responseData => {
  if (responseData?.pharmacies?.length) {
    const pharmacyList = responseData.pharmacies.map(pharmacy => {
      return {
        childrenData: {
          componentName: "Address",
          name: pharmacy.pharmacy_nm,
          address_line1: pharmacy.address.address_line1,
          city: pharmacy.address.city,
          state: pharmacy.address.state_province,
          zipCode: pharmacy.address.postal
        },
        key: "selectedData",
        type: "listItemWrapper",
        title: "",
        selectedData: pharmacy,
        childrenType: "pharmacy-address"
      };
    });

    return pharmacyList;
  }

  return [];
};
